import Error from "components/form/Error";
import InputAreaPrice from "components/form/InputAreaPrice";
import InputAreaPrime from "components/form/InputAreaPrime";
import LabelArea from "components/form/LabelArea";

import React, { useState, useEffect } from "react";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import SelectVehicleCatBasic from "./SelectVehicleCatBasic";

const DynamicHourRentalInput = ({
  setSelectedOptions,
  selectedOptions,
  setDataInput,
  dataInput,
  register,
  trigger,
  errors,
  handleVehicleCategoryChange,
  handleChange,
  primeAvailable,
}) => {
  const handleClick = () => {
    setDataInput((prevData) => [
      ...prevData,
      {
        ["vehicle_type_" + prevData.length]: "",
        ["4h_40km_" + prevData.length]: "",
        ["6h_60km_" + prevData.length]: "",
        ["8h_80km_" + prevData.length]: "",
        ["10h_100km_" + prevData.length]: "",
        ["extra_km_" + prevData.length]: "",
        ["extra_hr_" + prevData.length]: "",
        ["prime_" + prevData.length]: "",
      },
    ]);
    setSelectedOptions((prevOptions) => {
      // console.log(prevOptions,'prevOptions');
      return [...prevOptions];
    });
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [primeStates, setPrimeStates] = useState({}); // Tracks is_prime status for each instance
  useEffect(() => {
    setPrimeStates((prevState) => {
      // Create a new state object by preserving existing indices
      const newPrimeStates = { ...prevState };

      dataInput.forEach((item, index) => {
        const vehicleType = item[`vehicle_type_${index}`];

        // Only set prime state if not already set (preserve for "add" mode)
        if (
          !newPrimeStates.hasOwnProperty(index) &&
          vehicleType &&
          primeAvailable?.hasOwnProperty(vehicleType)
        ) {
          newPrimeStates[index] = primeAvailable[vehicleType];
        }
      });

      return newPrimeStates;
    });
  }, [dataInput, primeAvailable]);
  const handlePrimeStatusChange = (index, primeStatus) => {
    setPrimeStates((prevState) => ({
      ...prevState,
      [index]: primeStatus,
    }));
  };
  const handleDelete = (i) => {
    setSelectedOptions((prevOptions) => {
      const deleteVal = dataInput[i][`vehicle_type_${i}`];
      const updatedOptions = prevOptions.filter(
        (option) => option !== deleteVal,
      );
      return updatedOptions;
    });

    setDataInput((prevData) => {
      const newData = prevData.filter((_, index) => index !== i);

      const reIndexedData = newData.map((item, index) => {
        return {
          [`vehicle_type_${index}`]:
            item[
              Object.keys(item).find((key) => key.startsWith("vehicle_type"))
            ] || "",
          [`rate_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("rate"))] || "",
          [`prime_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("prime"))] ||
            "",
          [`4h_40km_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("4h_40km"))] ||
            "",
          [`6h_60km_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("6h_60km"))] ||
            "",
          [`8h_80km_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("8h_80km"))] ||
            "",
          [`10h_100km_${index}`]:
            item[
              Object.keys(item).find((key) => key.startsWith("10h_100km"))
            ] || "",
          [`extra_km_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("extra_km"))] ||
            "",
          [`extra_hr_${index}`]:
            item[Object.keys(item).find((key) => key.startsWith("extra_hr"))] ||
            "",
        };
      });

      return reIndexedData;
    });
  };

  const handleDeleteConfirm = () => {
    handleDelete(deleteIndex);
    setShowDeleteModal(false);
  };

  return (
    <div className="col-span-full relative">
      <div className="grid grid-cols-7 gap-5 col-span-7">
        <div>
          <LabelArea label={"Vehicle Type"} />
        </div>
        {/* <div>
          <LabelArea label={"4H 40KM"} />
        </div>
        <div>
          <LabelArea label={"6H 60KM"} />
        </div> */}
        <div>
          <LabelArea label={"8H 80KM"} />
        </div>
        <div>
          <LabelArea label={"10H 100KM"} />
        </div>
        <div>
          <LabelArea label={"Extra KM"} />
        </div>
        <div>
          <LabelArea label={"Extra HR"} />
        </div>
        <div>
          <LabelArea label={"Prime %"} />
        </div>
      </div>
      {dataInput.map((val, i) => (
        <div className="grid grid-cols-7 gap-5 mb-8 col-span-7" key={i}>
          <div className="">
            <SelectVehicleCatBasic
              register={register}
              label="Vehicle Type"
              name={`vehicle_type_${i}`}
              selectedVehicle={val[`vehicle_type_${i}`]}
              selectedOptions={selectedOptions}
              onChange={(e) => handleVehicleCategoryChange(e, i)}
              onPrimeStatusChange={(primeStatus) =>
                handlePrimeStatusChange(i, primeStatus)
              }
              type="text"
              placeholder="--Choose--"
            />
            <Error errorName={errors[`vehicle_type_${i}`]} />
          </div>
          {/* <div className="">
            <InputAreaPrice
              register={register}
              trigger={trigger}
              label="4H 40KM"
              type="text"
              maxLength={5}
              name={`4h_40km_${i}`}
              value={val[`4h_40km_${i}`]}
              onChangeFunction={(e) => handleChange(e, i)}
              placeholder={"ex: 1000"}
            />
            <Error errorName={errors[`4h_40km_${i}`]} />
          </div> */}
          {/* <div className="">
            <InputAreaPrice
              register={register}
              trigger={trigger}
              name={`6h_60km_${i}`}
              label="6H 60KM"
              type="text"
              maxLength={5}
              value={val[`6h_60km_${i}`]}
              onChangeFunction={(e) => handleChange(e, i)}
              placeholder={"ex: 1000"}
            />
            <Error errorName={errors[`6h_60km_${i}`]} />
          </div> */}
          <div className="">
            <InputAreaPrice
              register={register}
              trigger={trigger}
              name={`8h_80km_${i}`}
              label="8H 80KM"
              type="text"
              maxLength={5}
              value={val[`8h_80km_${i}`]}
              onChangeFunction={(e) => handleChange(e, i)}
              placeholder={"ex: 1000"}
            />
            <Error errorName={errors[`8h_80km_${i}`]} />
          </div>

          <div className="">
            <InputAreaPrice
              register={register}
              trigger={trigger}
              name={`10h_100km_${i}`}
              label="10H 100KM"
              type="text"
              maxLength={5}
              value={val[`10h_100km_${i}`]}
              onChangeFunction={(e) => handleChange(e, i)}
              placeholder={"ex: 1000"}
            />
            <Error errorName={errors[`10h_100km_${i}`]} />
          </div>

          <div className="">
            <InputAreaPrice
              register={register}
              trigger={trigger}
              label="Extra KM"
              type="text"
              maxLength={5}
              name={`extra_km_${i}`}
              value={val[`extra_km_${i}`]}
              onChangeFunction={(e) => handleChange(e, i)}
              placeholder={"ex: 10"}
            />
            <Error errorName={errors[`extra_km_${i}`]} />
          </div>
          <div className="">
            <InputAreaPrice
              register={register}
              trigger={trigger}
              name={`extra_hr_${i}`}
              label="Extra HR"
              type="text"
              maxLength={5}
              value={val[`extra_hr_${i}`]}
              onChangeFunction={(e) => handleChange(e, i)}
              placeholder={"ex: 10"}
            />
            <Error errorName={errors[`extra_hr_${i}`]} />
          </div>
          {primeStates[i] ? (
            <div className="">
              <InputAreaPrime
                register={register}
                trigger={trigger}
                name={`prime_${i}`}
                label="Prime"
                type="text"
                value={val[`prime_${i}`]}
                onChangeFunction={(e) => handleChange(e, i)}
                maxLength={2}
                placeholder="0"
              />
              <Error errorName={errors[`prime_${i}`]} />
            </div>
          ) : (
            "Not available"
          )}

          <div className="flex items-center">
            {Object.keys(dataInput).length !== 1 && (
              <button
                style={{ top: "1rem", outline: "none", color: "grey" }}
                className="ml-8 outline-none"
                type="button"
                aria-label="Remove item"
                onClick={() => {
                  setDeleteIndex(i);
                  setShowDeleteModal(true);
                }}
              >
                X
              </button>
            )}
          </div>
        </div>
      ))}
      <div className="mt-6 lg:mt-1">
        <button
          style={{ color: "#0e9f6e", fontSize: "42px", outline: "none" }}
          className="absolute bottom-0 right-0 outline-none"
          type="button"
          onClick={handleClick}
        >
          +
        </button>
      </div>
      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
      />
    </div>
  );
};

export default DynamicHourRentalInput;
